import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getGeneralRecommendations } from "../../api/recommendations/recommendationAPI";
import LoadingPlaceholder from "../ui/loading/LoadingPlaceholder";

function PrivateRecommendation() {
  // State for expandable sections
  const [isExpanded, setIsExpanded] = useState(false);
  const [isRecommendedExpanded, setIsRecommendedExpanded] = useState(false);

  // State for API data
  const [latestArticles, setLatestArticles] = useState([]);
  const [recommendedArticles, setRecommendedArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch recommendations data
  useEffect(() => {
    const fetchRecommendations = async () => {
      try {
        const response = await getGeneralRecommendations();

        if (response.ok) {
          const data = await response.json();
          setLatestArticles(data.lat_art || []);
          setRecommendedArticles(data.rec_art || []);
        }
      } catch (err) {
        console.error("Error fetching recommendations:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchRecommendations();
  }, []);

  return (
    <>
      {loading ? (
        <div className="right-sidebar-element">
          <LoadingPlaceholder rows={2} type="card" />
        </div>
      ) : (
        <>
          {/* Element 1 - Latest Articles */}
          <div className="right-sidebar-element">
            <h3 className="right-sidebar-title">Latest</h3>
            {latestArticles.length > 0 ? (
              <>
                <Link
                  to={`blog/article/${latestArticles[0].id}`}
                  className="right-sidebar-card"
                >
                  <img
                    src={latestArticles[0].creative}
                    alt={latestArticles[0].title}
                    className="right-sidebar-card-image"
                  />
                  <span className="right-sidebar-card-link">
                    {latestArticles[0].title}
                  </span>
                </Link>

                {/* Additional Cards (Hidden by default) */}
                {latestArticles.length > 1 && (
                  <div
                    className={`right-sidebar-additional-cards ${
                      isExpanded ? "expanded" : "collapsed"
                    }`}
                  >
                    {latestArticles.slice(1).map((article, index) => (
                      <Link
                        key={article.id || index}
                        to={`/blog/article/${article.id}`}
                        className="right-sidebar-card"
                      >
                        <img
                          src={article.creative}
                          alt={article.title}
                          className="right-sidebar-card-image"
                        />
                        <span className="right-sidebar-card-link">
                          {article.title}
                        </span>
                      </Link>
                    ))}
                  </div>
                )}
                {latestArticles.length > 1 && (
                  <div className="right-sidebar-divider">
                    <img
                      src={
                        isExpanded
                          ? `${process.env.PUBLIC_URL}/images/icons/less_blue_light.svg`
                          : `${process.env.PUBLIC_URL}/images/icons/more_blue_light.svg`
                      }
                      alt="Show more"
                      className={`right-sidebar-arrow ${
                        isExpanded ? "rotated" : ""
                      }`}
                      onClick={() => setIsExpanded(!isExpanded)}
                    />
                  </div>
                )}
              </>
            ) : null}
          </div>

          {/* Element 2 - Recommended Articles */}
          <div className="right-sidebar-element">
            <h3 className="right-sidebar-title">Recommended</h3>
            {recommendedArticles.length > 0 ? (
              <div className="right-sidebar-news">
                <div className="right-sidebar-news-item">
                  <img
                    src={`${process.env.PUBLIC_URL}/images/icons/news.svg`}
                    alt="News"
                    className="right-sidebar-news-icon"
                  />
                  <Link
                    to={`blog/article/${recommendedArticles[0].id}`}
                    className="right-sidebar-news-link"
                  >
                    {recommendedArticles[0].title}
                  </Link>
                </div>

                {/* Additional News Items (Hidden by default) */}
                {recommendedArticles.length > 1 && (
                  <div
                    className={`right-sidebar-additional-news ${
                      isRecommendedExpanded ? "expanded" : "collapsed"
                    }`}
                  >
                    {recommendedArticles.slice(1).map((article, index) => (
                      <div
                        key={article.id || index}
                        className="right-sidebar-news-item"
                      >
                        <img
                          src={`${process.env.PUBLIC_URL}/images/icons/news.svg`}
                          alt="News"
                          className="right-sidebar-news-icon"
                        />
                        <Link
                          to={`blog/article/${article.id}`}
                          className="right-sidebar-news-link"
                        >
                          {article.title}
                        </Link>
                      </div>
                    ))}
                  </div>
                )}
                {recommendedArticles.length > 1 && (
                  <div className="right-sidebar-divider">
                    <img
                      src={
                        isRecommendedExpanded
                          ? `${process.env.PUBLIC_URL}/images/icons/less_blue_light.svg`
                          : `${process.env.PUBLIC_URL}/images/icons/more_blue_light.svg`
                      }
                      alt="Show more"
                      className={`right-sidebar-arrow ${
                        isRecommendedExpanded ? "rotated" : ""
                      }`}
                      onClick={() =>
                        setIsRecommendedExpanded(!isRecommendedExpanded)
                      }
                    />
                  </div>
                )}
              </div>
            ) : null}
          </div>
        </>
      )}
    </>
  );
}

export default PrivateRecommendation;
